import React from "react";
import { appConfig } from "./config";

export const AppConfigContext = React.createContext(appConfig);
